import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { IndicatorBoxModel } from '../../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../../models/qfilter.model';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { NumberKMPipe } from './../../../../../pipes/numberKMPipe';

// Pagina 47
@Component({
  selector: 'app-promo-overview-main-kpi',
  templateUrl: './promo-overview-main-kpi.component.html',
  styleUrls: ['./promo-overview-main-kpi.component.css']
})
export class PromoOverviewMainKpiComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public storeError = false;
  public data: QFilterModel;
  public categoryInvestmentPie: LoyaltyChart;
  public categoryInvestmentColumn: LoyaltyChart;
  public averageDiscount: LoyaltyChart;
  public investmentContactPie: LoyaltyChart;

  constructor (
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) { }

  ngOnInit() {
    this.initCharts();
  }

  initCharts() {
    this.categoryInvestmentPie = new LoyaltyChart('pie');

    this.categoryInvestmentColumn = new LoyaltyChart('column');
    this.categoryInvestmentColumn.options.legend = {layout: 'horizontal', align: 'center', verticalAlign: 'bottom'};  /*Q206*/
    this.categoryInvestmentColumn.options.plotOptions = { column: {stacking: 'normal'} };
    this.categoryInvestmentColumn.options.xAxis = {type: 'category'};
    this.categoryInvestmentColumn.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };


    this.averageDiscount = new LoyaltyChart('column');
    this.averageDiscount.options.xAxis = {type: 'category'};
    this.averageDiscount.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '%');
    };
    this.averageDiscount.options.legend.enabled = false;

    this.investmentContactPie = new LoyaltyChart('pie');
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }


  searchValue(data: QFilterModel) {
    this.data = data;

    this.indicators = [];

    Observable.zip(
      this.indicatorService.indicatorCalculation('promos.Q186', this.data),
      this.indicatorService.indicatorCalculation('promos.Q188', this.data)
    ).subscribe(
      ([q186, q188]) => {

        /*186*/
        this.indicators.push(new IndicatorBoxModel([q186.find(r => r.name === 'investimento')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
        /*187*/
        this.indicators.push(new IndicatorBoxModel([q186.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
        /*188*/
        this.indicators.push(new IndicatorBoxModel([q188.find(r => r.name === 'round')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
        /*189*/
        this.indicators.push(new IndicatorBoxModel([q186.find(r => r.name === 'sconto_medio_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));

      });


    this.categoryInvestmentPieInit (data);
    this.categoryInvestmentColumnInit (data);
    this.averageDiscountColumnInit (data);
    this.investmentContactPieInit (data);
    this.show_results = true;

  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  categoryInvestmentPieInit (data) {

    Observable.zip (
      this.indicatorService.getChart('promos.Q190', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i]} );
      }

      let h = series.length * 45;
      h = h < 370 ? 370 : h;
      this.categoryInvestmentPie.options.chart.height = h;

      if (this.categoryInvestmentPie.instance) {
        while (this.categoryInvestmentPie.instance.series.length > 0) {
          this.categoryInvestmentPie.instance.series[0].remove(true);
        }
      }


      this.categoryInvestmentPie.options.series = [{ name: '', colorByPoint: true, data: series }];
      this.categoryInvestmentPie.options.chart.height = 370;
      this.categoryInvestmentPie.options.tooltip = {
        formatter: function() {
          return this.key + ': <b>' + NumberKMPipe.formatDynamic(this.y, '€') + '</b> (' + NumberKMPipe.formatDynamic(this.percentage, '%') + ')';
        }
      };

      this.categoryInvestmentPie.instance.addSeries(series);

      this.categoryInvestmentPie.instance.update(this.categoryInvestmentPie.options);
      this.categoryInvestmentPie.instance.redraw();

    });
  }

  categoryInvestmentColumnInit (data) {

    Observable.zip (
      this.indicatorService.getChart('promos.Q191', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let serie2 = res.series[2].serie;
      const xAxis = {
        serie: serie0.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })
      };

      let series: Array<any> = [];
      for (let i = 0; i < serie0.length; i++) {
        let elem = series.find(function (item) {
          return item.name === serie1[i];
        });
        if (typeof elem === 'undefined') {
          series.push({name: serie1[i], data: [serie2[i]]});
        } else {
          elem.data.push(serie2[i]);
        }
      }

      let h = (series.length * 120) + 10;
      h = h < 370 ? 370 : h;
      this.categoryInvestmentColumn.options.chart.height = h;


      if (this.categoryInvestmentColumn.instance) {
        while (this.categoryInvestmentColumn.instance.series.length > 0) {
          this.categoryInvestmentColumn.instance.series[0].remove(true);
        }
      }

      this.categoryInvestmentColumn.options.xAxis.categories = xAxis.serie;
      this.categoryInvestmentColumn.options.tooltip = {
        formatter: function() {
          return this.key + ': <b>' + NumberKMPipe.formatDynamic(this.y, '€') + '</b>';
        }
      };

      for (let i = 0; i < series.length; i++) {

        this.categoryInvestmentColumn.instance.addSeries(series[i]);
      }
      this.categoryInvestmentColumn.instance.update(this.categoryInvestmentColumn.options);
      this.categoryInvestmentColumn.instance.redraw();
    });
  }


  averageDiscountColumnInit (data) {

    Observable.zip (
      this.indicatorService.getChart('promos.Q192', data, false)
    ).subscribe( ([res]) => {
      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i]} );
      }

      let h = series.length * 45;
      h = h < 370 ? 370 : h;
      this.averageDiscount.options.chart.height = h;

      if (this.averageDiscount.instance) {
        while (this.averageDiscount.instance.series.length > 0) {
          this.averageDiscount.instance.series[0].remove(true);
        }
      }


      this.averageDiscount.options.series = [{ name: '', colorByPoint: true, data: series }];
      this.averageDiscount.options.chart.height = 370;
      this.averageDiscount.options.tooltip = {
        formatter: function() {
          return this.key + ': <b>' + NumberKMPipe.formatDynamic(this.y, '%') + '</b>';
        }
      };

      this.averageDiscount.instance.addSeries(series);

      this.averageDiscount.instance.update(this.averageDiscount.options);
      this.averageDiscount.instance.redraw();

    });
  }


  investmentContactPieInit (data) {

    Observable.zip (
      this.indicatorService.getChart('promos.Q193', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i]} );
      }

      let h = series.length * 45;
      h = h < 370 ? 370 : h;
      this.investmentContactPie.options.chart.height = h;

      if (this.investmentContactPie.instance) {
        while (this.investmentContactPie.instance.series.length > 0) {
          this.investmentContactPie.instance.series[0].remove(true);
        }
      }


      this.investmentContactPie.options.series = [{ name: '', colorByPoint: true, data: series }];
      this.investmentContactPie.options.chart.height = 370;
      this.investmentContactPie.options.tooltip = {
        formatter: function() {
          return this.key + ': <b>' + NumberKMPipe.formatDynamic(this.y, '€') + '</b> (' + NumberKMPipe.formatDynamic(this.percentage, '%') + ')';
        }
      };


      this.investmentContactPie.instance.addSeries(series);

      this.investmentContactPie.instance.update(this.investmentContactPie.options);
      this.investmentContactPie.instance.redraw();

    });
  }

  resetData() {
    this.show_results = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/overview-main-kpi/promo-overview-main-kpi.component.ts